import { config } from 'utils/config/env';

// !IMPORTANT: These flags are used to toggle features (small or big) on and off.
// Most commonly used to have specific changes for a demo.

const env = config.VITE_ENV || 'development';
export const ALLOW_DEVELOPMENT = env === 'development';
export const ALLOW_DEMO = env === 'demo';
export const ALLOW_STAGING = env === 'staging';

export const featureFlags = {
  // !IMPORTANT: Switch this to true to display all pages.
  // Enable this by default only in development so local environments can see all modules
  // (useful for E2E and exploratory testing) without affecting staging/production.
  FF__DISPLAY_ALL_PAGES: ALLOW_DEVELOPMENT,

  // Maxi AI feature flags
  FF__ASK_MAXI_AI_BUTTON: ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,

  // Subledgers-Module feature flags
  FF__SHOW_ASSETS_MODULE: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  FF__SHOW_FIXED_ASSETS: ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,
  FF__SHOW_PREPAIDS: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  FF__ASSETS_AUTO_VIEW_FROM_QUERY: ALLOW_DEVELOPMENT || ALLOW_DEMO,

  // Revenue-Module feature flags
  FF__SHOW_REVENUE_MODULE: ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,
  FF__SHOW_REVENUE_OVERVIEW: ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,
  FF__SHOW_REVENUE_RECONCILIATION_TAB:
    ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,
  FF__SHOW_REVENUE_REPORTING_TAB: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  FF__SHOW_REVENUE_CHECKLIST: false,
  FF__SHOW_REVENUE_UPLOADS: ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,

  // Cash-Module feature flags
  FF__CASH_DEMO_HARDCODED_DATES: ALLOW_DEMO,
  FF__CASH_MANUAL_MATCH: ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,
  FF__CASH_MANUAL_RECONCILE: ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,
  FF__CASH_RULESETS: ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,
  FF__CASH_REPORTING: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  FF__CASH_DASHBOARD: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  FF__AI_COULDNT_MATCH: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  FF__CASH_RECORD_APPROVED_TRANSACTION_IN_ERP:
    ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,
  FF__CASH_POLICIES: ALLOW_DEVELOPMENT || ALLOW_DEMO,

  // Reporting-Module feature flags
  FF__REPORTS_DEMO_DEFAULT_DATE: ALLOW_DEMO,
  FF__REPORTS_HUB_DEMO_OPTIONS: false,
  FF__DEMO_ONLY_MONITORING_NEW_RULE: ALLOW_DEMO,
  FF__DEMO_ONLY_FINANCIAL_ANALYSIS_CREATE: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  FF__REPORTS_HUB_DEMO_CASH_FLOW_DIRECT: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  FF__REPORTS_HUB_DEMO_CASH_FLOW_FORECAST: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  FF__BUDGETS_VS_ACTUALS_USE_MOCK_DATA: ALLOW_DEMO,
  FF__KPI_METRICS_REVENUE_METRICS:
    ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,
  FF__SYNC_ALL_REPORTS: ALLOW_DEVELOPMENT || ALLOW_DEMO || ALLOW_STAGING,

  // Flux Analysis feature flags
  FF__FLUX_ANALYSIS_DEMO_DRAWER_DATA: false,
  FF__FLUX_ANALYSIS_DEMO_DRILL_DOWN: ALLOW_DEMO,

  // Close feature flags
  FF__CLOSE_CALENDAR_VIEW: ALLOW_DEVELOPMENT || ALLOW_STAGING,
  FF__CLOSE_MONTH_CLOSE: ALLOW_DEMO,

  // Workflows feature flags
  FF__SHOW_WORKFLOWS_MODULE: ALLOW_DEVELOPMENT || ALLOW_DEMO,

  // Demo feature flags
  FF__DEMO_CLOSE_INSIGHTS_DATA: ALLOW_DEMO,
  FF__CLOSE_DEMO_PAGES: ALLOW_DEMO, // Set to true to enable demo reconciliation/checklist components

  // AP and Accruals feature flags
  FF__SHOW_AP_AND_ACCRUALS: ALLOW_DEVELOPMENT || ALLOW_DEMO,

  // Consolidation feature flags
  FF__INTERCOMPANY_DEMO_DEFAULT_DATE: ALLOW_DEMO,

  // Settings feature flags
  FF__SHOW_CURRENCY_CONVERSION: ALLOW_DEMO,
  FF__SHOW_NOTIFICATIONS_DEBUG_MODE: ALLOW_DEVELOPMENT || ALLOW_STAGING,

  // Integrations feature flags
  FF__SHOW_DEMO_INTEGRATIONS: ALLOW_DEVELOPMENT || ALLOW_DEMO,

  // Data Catalog feature flags
  FF__DATA_CATALOG_DEMO: ALLOW_DEVELOPMENT || ALLOW_DEMO,

  // Azumi Demo Reports
  FF__EXECUTIVE_REPORT_DEMO: ALLOW_DEVELOPMENT || ALLOW_DEMO,
  // Azumi POC feature flags
  FF__AZUMI_POC: ALLOW_DEVELOPMENT || ALLOW_DEMO,

  // Sigma Computing embed
  FF__SIGMA_EMBED_REPORT: ALLOW_DEVELOPMENT || ALLOW_DEMO,
};
